import type { FileTemplateRouter } from "replo-publisher/src/trpc/routers/fileTemplate";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: fileTemplateRouter,
  client: fileTemplateClient,
  utils: fileTemplateUtils,
  options: fileTemplateOptions,
} = createTrpcRouterConfig<FileTemplateRouter>({
  path: "fileTemplate",
  queryClient: getNamespacedQueryClient("fileTemplate"),
});

export {
  fileTemplateClient,
  fileTemplateRouter,
  fileTemplateUtils,
  fileTemplateOptions,
};
